<template>
    <div>
        <div class='tableauPlaceholder' id='viz1603105139990' style='position: relative'>
            <noscript><a href='#'><img alt=' ' src='https://public.tableau.com/static/images/In/InvoiceByProduct/InvoiceByProduct/1_rss.png' style='border: none' /></a></noscript>
            <object class='tableauViz'  style='display:none;'>
                <param name='host_url' value='https://public.tableau.com/' />
                <param name='embed_code_version' value='3' />
                <param name='site_root' value='' />
                <param name='name' value='InvoiceByProduct/InvoiceByProduct' />
                <param name='tabs' value='no' />
                <param name='toolbar' value='yes' />
                <param name='static_image' value='https://public.tableau.com/static/images/In/InvoiceByProduct/InvoiceByProduct/1.png' />
                <param name='animate_transition' value='yes' /><param name='display_static_image' value='yes' />
                <param name='display_spinner' value='yes' />
                <param name='display_overlay' value='yes' />
                <param name='display_count' value='yes' />
                <param name='language' value='en' />
                <param name='filter' value='publish=yes' /></object>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InvoiceReport",
        mounted() {
            this.initTableau();
        },
        methods: {
            initTableau(){
                var divElement = document.getElementById('viz1603105139990');
                var vizElement = divElement.getElementsByTagName('object')[0];
                if ( divElement.offsetWidth > 800 ) { vizElement.style.width='1400px';vizElement.style.height='827px';}
                else if ( divElement.offsetWidth > 500 ) { vizElement.style.width='1400px';vizElement.style.height='827px';}
                else { vizElement.style.width='100%';vizElement.style.height='727px';}
                var scriptElement = document.createElement('script');
                scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
                vizElement.parentNode.insertBefore(scriptElement, vizElement);
            }
        }
    }
</script>

<style scoped>

</style>
